import { Lease, leaseSchema } from "@boark/shared/types/lease";
import { LeaseCreate } from "@boark/shared/types/lease-create";
import { LeaseUpdate } from "@boark/shared/types/lease-update";
import {
  LeaseWithApartmentAndSublets,
  leaseWithApartmentAndSubletsSchema,
} from "@boark/shared/types/lease-with-apartment-and-sublets";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getLeases(): Promise<LeaseWithApartmentAndSublets[]> {
  return getRequest(
    `${API_BASE_URL}/lease`,
    z.array(leaseWithApartmentAndSubletsSchema),
  );
}

export async function getLease(
  id: string,
): Promise<LeaseWithApartmentAndSublets> {
  return await getRequest(
    `${API_BASE_URL}/lease/${id}`,
    leaseWithApartmentAndSubletsSchema,
  );
}

export async function createLease(lease: LeaseCreate): Promise<Lease> {
  return await postRequest(`${API_BASE_URL}/lease`, lease, leaseSchema);
}

export async function updateLease(
  id: string,
  lease: LeaseUpdate,
): Promise<Lease> {
  return await putRequest(`${API_BASE_URL}/lease/${id}`, lease, leaseSchema);
}

export async function deleteLease(id: string): Promise<void> {
  return await deleteRequest(`${API_BASE_URL}/lease/${id}`);
}
